
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pdf-viewer",
      function () {
        return require("private-next-pages/pdf-viewer/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pdf-viewer"])
      });
    }
  